module.exports = __webpack_public_path__ + "static/img/font-5.e892a95d.svg";